module.exports = __webpack_public_path__ + "img/ai_assistant_avatar.dc456247.svg";